import { render, staticRenderFns } from "./PExperiencedProject.vue?vue&type=template&id=164b0e6c&"
import script from "./PExperiencedProject.vue?vue&type=script&lang=ts&"
export * from "./PExperiencedProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports